module.exports = __webpack_public_path__ + "img/5-gallery.f11fdf61.jpg";